import { Factory, Desktop, Circuitry, Armchair } from '@phosphor-icons/react';

// Scanner Hub profiles — ONE shared engine (camera / barcode reader / cart /
// scan feedback / session history). Each profile only customises the available
// modes, labels, scan guards and destination data source. Add a new profile
// here instead of building a separate scanner app.
export const PROFILES = [
  {
    id: 'mfg',
    icon: Factory,
    titleKey: 'scanner.gate.mfg.title',
    descKey: 'scanner.gate.mfg.desc',
    bullets: ['入庫 / 出庫 / 棚卸', '設備の貸出 / 返却'],
    modes: ['stock_in', 'stock_out', 'stocktake', 'lend', 'return'],
    defaultMode: 'stock_in',
    deptRequired: true,
    lockHint: 'mfg_edit 権限が必要です',
    theme: {
      icon: 'text-cyan-600', iconBg: 'bg-cyan-50 group-hover:bg-cyan-100',
      cardHover: 'hover:border-cyan-400',
      accentText: 'text-cyan-500',
      tabActive: 'bg-cyan-600 border-cyan-600 text-white',
      guideBox: 'border-cyan-200 bg-cyan-50/50', guideHover: 'hover:bg-cyan-50',
      guideHead: 'text-cyan-800', guideBulb: 'text-cyan-500', guideToggle: 'text-cyan-600', guideStep: 'bg-cyan-500',
      chip: 'bg-cyan-50 text-cyan-700 border-cyan-200 hover:bg-cyan-100',
    },
  },
  {
    id: 'it',
    icon: Desktop,
    titleKey: 'scanner.gate.it.title',
    descKey: 'scanner.gate.it.desc',
    bullets: ['情報表示 / 貸出 / 返却', '割当 / 棚卸 / 場所移動'],
    modes: ['lookup', 'lend', 'return', 'assign', 'verify', 'move'],
    defaultMode: 'lookup',
    deptRequired: false,
    lockHint: 'it_edit 権限が必要です',
    theme: {
      icon: 'text-indigo-600', iconBg: 'bg-indigo-50 group-hover:bg-indigo-100',
      cardHover: 'hover:border-indigo-400',
      accentText: 'text-indigo-500',
      tabActive: 'bg-indigo-600 border-indigo-600 text-white',
      guideBox: 'border-indigo-200 bg-indigo-50/50', guideHover: 'hover:bg-indigo-50',
      guideHead: 'text-indigo-800', guideBulb: 'text-indigo-500', guideToggle: 'text-indigo-600', guideStep: 'bg-indigo-500',
      chip: 'bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100',
    },
  },
  {
    id: 'eng',
    icon: Circuitry,
    titleKey: 'scanner.gate.eng.title',
    descKey: 'scanner.gate.eng.desc',
    bullets: ['情報表示', '使用 / 返却 / 廃棄（技術メンバー）'],
    modes: ['lookup', 'eng_use', 'eng_return', 'eng_scrap'],
    memberModes: ['eng_use', 'eng_return', 'eng_scrap'],
    defaultMode: 'lookup',
    deptRequired: false,
    theme: {
      icon: 'text-teal-600', iconBg: 'bg-teal-50 group-hover:bg-teal-100',
      cardHover: 'hover:border-teal-400',
      accentText: 'text-teal-500',
      tabActive: 'bg-teal-600 border-teal-600 text-white',
      guideBox: 'border-teal-200 bg-teal-50/50', guideHover: 'hover:bg-teal-50',
      guideHead: 'text-teal-800', guideBulb: 'text-teal-500', guideToggle: 'text-teal-600', guideStep: 'bg-teal-500',
      chip: 'bg-teal-50 text-teal-700 border-teal-200 hover:bg-teal-100',
    },
  },
  {
    id: 'bihin',
    icon: Armchair,
    titleKey: 'scanner.gate.bihin.title',
    descKey: 'scanner.gate.bihin.desc',
    bullets: ['情報表示 / 貸出 / 返却', '消耗品の在庫調整（bihin_edit）'],
    modes: ['lookup', 'lend', 'return', 'bihin_stock'],
    editModes: ['bihin_stock'],
    defaultMode: 'lookup',
    deptRequired: false,
    theme: {
      icon: 'text-emerald-600', iconBg: 'bg-emerald-50 group-hover:bg-emerald-100',
      cardHover: 'hover:border-emerald-400',
      accentText: 'text-emerald-500',
      tabActive: 'bg-emerald-600 border-emerald-600 text-white',
      guideBox: 'border-emerald-200 bg-emerald-50/50', guideHover: 'hover:bg-emerald-50',
      guideHead: 'text-emerald-800', guideBulb: 'text-emerald-500', guideToggle: 'text-emerald-600', guideStep: 'bg-emerald-500',
      chip: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100',
    },
  },
];

export const PROFILE_MAP = Object.fromEntries(PROFILES.map((p) => [p.id, p]));

// Which resolve kinds each profile accepts, per mode.
export function allowedKinds(profileId, mode) {
  if (profileId === 'mfg') {
    return ['stock_in', 'stock_out', 'stocktake'].includes(mode) ? ['item', 'lot'] : ['equipment'];
  }
  if (profileId === 'it') return ['it_asset'];
  if (profileId === 'eng') return ['eng_asset'];
  if (profileId === 'bihin') return ['bihin'];
  return [];
}

export const KIND_LABEL = {
  item: '在庫品目', lot: 'ロット', equipment: '設備',
  it_asset: 'IT資産', eng_asset: '技術資産', bihin: '備品',
};
